__turbopack_context__.v({
  "className": "playfair_display_d66b92bc-module__gyRDPG__className",
});
